import React from 'react';

export function useCombinedRefs(...refs) {
  const targetRef = React.useRef(null);

  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else if (targetRef.current) {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}
